import { pubsub } from '../utils/pubsub';
import { useConnectionContext } from '../contexts/ConnectionContext';
import { devLog } from '../utils/devLog';

export function useDeviceWriter() {
  const { macAddress } = useConnectionContext();

  async function writeRegister(address, value) {
    const topic = 'dontek' + macAddress + '/cmd/psw';
    const message = { messageId: 'write', modbusReg: address, modbusVal: [value] };
    await pubsub.publish({
      topics: topic,
      message: message,
      options: { provider: 'AWSIoTProvider' },
    });

    devLog(topic, '=>', message);
  }

  async function writeValueStringRegister(address, value, valueString) {
    const topic = 'dontek' + macAddress + '/cmd/psw';

    const message = { messageId: 'write', modbusReg: address, modbusVal: [value], valueString: valueString };
    await pubsub.publish({
      topics: topic,
      message: message,
    });

    // valueString can carry a device password (see writePasswordRegister) —
    // never log it verbatim.
    devLog(topic, '=>', { ...message, valueString: '<redacted>' });
  }

  async function writePasswordRegister(address, value) {
    let password = '_d0nt3k2K19';

    return writeValueStringRegister(address, value, password);
  }

  async function writeRegisters(startAddress, values) {
    const topic = 'dontek' + macAddress + '/cmd/psw';
    const message = { messageId: 'write', modbusReg: startAddress, modbusVal: values };
    await pubsub.publish({
      topics: topic,
      message: message,
      options: { provider: 'AWSIoTProvider' },
    });

    devLog(topic, '=>', message);
  }

  return { writeRegister, writePasswordRegister, writeValueStringRegister, writeRegisters };
}
